<script setup lang="ts">
  defineProps<{
    title?: string,
    icon?: string,
  }>()
</script>

<template>
  <div
    class="card"
    :class="{ 'mt-6': icon }">
    <div class="flex flex-wrap mb-8">
      <div class="flex space-x-4 min-w-0 pr-4">
        <div
          v-if="icon"
          class="card-icon">
          <fa-icon :icon="icon" />
        </div>
        <h2
          v-if="title"
          class="card-title">
          {{ title }}
        </h2>
      </div>
      <div class="card-buttons">
        <slot name="buttons"></slot>
      </div>
    </div>
    <div class="card-content">
      <slot></slot>
    </div>
  </div>
</template>

<style scoped>
  @reference "@/assets/styles/main.css";
  .card {
    @apply px-4 pb-4 lg:px-6 mb-12;
    @apply min-w-0; /* make sure title is still truncated when card is put on a flex container */
  }
  .card-icon {
    @apply bg-primary text-white;
    @apply -mt-4 size-16;
    @apply flex shrink-0 items-center justify-center text-2xl;
    @apply rounded;
  }
  .card-title {
    @apply truncate font-bold text-xl;
    @apply text-primary mt-4;
  }
  .card-buttons {
    @apply flex-1 flex items-start justify-end space-x-2;
  }
  :deep(.card-buttons) {
    button,
    a {
      @apply mt-4;
    }
  }
</style>
